import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { logobpom  } from "../imagepath";
import DarkMode from "../common/darkMode";
const Header2 = () => {
  // change header background on scroll
  const [navbar, setNavbar] = useState(false);
  const location = useLocation();
  const changeHeaderBackground = () => {
    if (window.scrollY >= 90) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };


  const openMobileMenu = () => {
    document.body.classList.add("menu-opened");
  };
  const hideMobileMenu = () => {
    document.body.classList.remove("menu-opened");
  };
  

  window.addEventListener("scroll", changeHeaderBackground);
  return (
    <header className="header header-two">
      <div className="header-fixed">
        <nav
          className={
            navbar
              ? "navbar navbar-expand-lg header-nav scroll-sticky add-header-bg"
              : "navbar navbar-expand-lg header-nav scroll-sticky"
          }
        >
          <div className="container">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#" onClick={openMobileMenu}>
                <span className="bar-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </Link>
              <Link to="/home" className="navbar-brand logo">
                <img src={logobpom} className="img-fluid" alt="Logo" />
              </Link>
            </div>
            <div className="main-menu-wrapper">
              <div className="menu-header">
                <Link to="/home" className="menu-logo">
                  <img src={logobpom} className="img-fluid" alt="Logo" />
                </Link>
                <Link
                  id="menu_close"
                  className="menu-close"
                  to="#"
                  onClick={hideMobileMenu}
                >
                  <i className="fas fa-times"></i>
                </Link>
              </div>
              <ul className="main-nav">
              <li className={location.pathname === "/home" ? "has-submenu menu-effect active" : "has-submenu menu-effect"}>
                  <Link to="/home" >
                    Home
                  </Link>
                </li>
                <li className={location.pathname === "/kategory/pangan" ? "has-submenu menu-effect active" : "has-submenu menu-effect"} >
                <Link to="/kategory/pangan">
                  Pangan{" "}
                  
                </Link>
                </li>
                <li className={location.pathname === "/kategory/kosmetik" ? "has-submenu menu-effect active" : "has-submenu menu-effect"} >
                <Link to="/kategory/kosmetik">
                  Kosmetik{" "}
                  
                </Link>
                </li>
                <li className={location.pathname === "/kategory/obat" ? "has-submenu menu-effect active" : "has-submenu menu-effect"} >
                <Link to="/kategory/obat">
                  Obat{" "}
                  
                </Link>
                </li>
                <li className={location.pathname === "/kategory/obat-bahan-alam" ? "has-submenu menu-effect active" : "has-submenu menu-effect"} >
                <Link to="/kategory/obat-bahan-alam">
                  Obat Bahan Alam{" "}
                  
                </Link>
                </li>
                <li>
                <Link target="_blank" to="https://drive.google.com/file/d/1ABUJmmDbl-Nw_QW2gluTVoZMdRXPoRnp/view?usp=sharing">
                  PNBP-PP32 Tahun 2017{" "}
                  
                </Link>
                </li>
              </ul>
            </div>
            <ul className="nav header-navbar-rht">
            <DarkMode/>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header2;
